<script>
  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";

  import { copyObjContent, getText } from "../../../Utils/utilFunctions.svelte";

  import { CardLayout } from "../index.svelte";

  export let exception = "";

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () => copyObjContent(exception, "Exception Copied!"),
      isHidden: !exception,
    },
  ];
</script>

<CardLayout title="Exception" {btnOptions}>
  <div class="flex flex-col p-2 w-full gap-y-3">
    <div class="flex flex-row gap-x-2">
      {#if exception}
        <p class="break-all">
          {getText(exception)}
        </p>
      {:else}
        <p>No exception</p>
      {/if}
    </div>
  </div>
</CardLayout>
